import React from "react";

export const Home = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Sectio      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 mt-8 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            PATRE
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Comunidade Terapêutica Cristo Rei - Transformando vidas com apoio,
            dedicação e esperança.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => scrollToSection("tratamento")}
              className="bg-gradient-to-r from-brand-yellow to-yellow-400 text-brand-blue font-bold font-montserrat py-4 px-10 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-yellow-400/50 transform hover:scale-110 transition-all duration-500 animate-bounce"
            >
              Tratamento
            </button>
            <button
              onClick={() => scrollToSection("quemSomos")}
              className="border-2 border-white text-white font-bold font-montserrat py-4 px-10 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Conheça-nos
            </button>
          </div>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mt-8 mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>
      {/* Stats Section */}
      <section id="estatisticas" className="py-20 bg-white text-brand-blue">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 shadow-xl hover:shadow-2xl smooth-transition hover:scale-105">
              <div className="text-6xl font-black font-montserrat text-brand-blue mb-4">
                500+
              </div>
              <p className="text-xl font-roboto">Vidas Transformadas</p>
            </div>
            <div className="p-8 rounded-2xl bg-gradient-to-br from-yellow-50 to-yellow-100 shadow-xl hover:shadow-2xl smooth-transition hover:scale-105">
              <div className="text-6xl font-black font-montserrat text-brand-blue mb-4">
                10+
              </div>
              <p className="text-xl font-roboto">Anos de Experiência</p>
            </div>
            <div className="p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 shadow-xl hover:shadow-2xl smooth-transition hover:scale-105">
              <div className="text-6xl font-black font-montserrat text-brand-blue mb-4">
                24/7
              </div>
              <p className="text-xl font-roboto">Suporte Contínuo</p>
            </div>
          </div>
        </div>
      </section>
      {/* Services Section with Cards */}
      <section
        id="servicos"
        className="py-20 bg-gradient-to-r from-slate-800 to-slate-900"
      >
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-5xl font-bold text-center font-montserrat mb-16 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
            Nossos Serviços
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group bg-gradient-to-br from-brand-blue/20 to-transparent p-8 rounded-3xl border border-brand-blue/30 hover:border-brand-yellow/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-brand-yellow/20">
              <div className="w-20 h-20 bg-gradient-to-br from-brand-yellow to-yellow-400 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-10 h-10 text-brand-blue"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 2L3 7v11a2 2 0 002 2h10a2 2 0 002-2V7l-7-5z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h3 className="text-3xl font-bold font-montserrat mb-4 text-center text-white">
                Tratamento
              </h3>
              <p className="text-gray-300 font-roboto text-center mb-6 leading-relaxed">
                Programa terapêutico completo focado no resgate da autonomia e
                cidadania.
              </p>
              <button
                onClick={() => scrollToSection("tratamento")}
                className="block text-center text-brand-yellow hover:text-yellow-300 font-semibold text-lg group-hover:underline transition-all duration-300"
              >
                Saiba mais →
              </button>
            </div>
            <div className="group bg-gradient-to-br from-brand-yellow/20 to-transparent p-8 rounded-3xl border border-brand-yellow/30 hover:border-brand-blue/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-brand-blue/20">
              <div className="w-20 h-20 bg-gradient-to-br from-brand-blue to-blue-400 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-10 h-10 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h3 className="text-3xl font-bold font-montserrat mb-4 text-center text-white">
                Quem Somos
              </h3>
              <p className="text-gray-300 font-roboto text-center mb-6 leading-relaxed">
                Nossa história, missão e valores na comunidade terapêutica.
              </p>
              <button
                onClick={() => scrollToSection("quemSomos")}
                className="block text-center text-brand-blue hover:text-blue-300 font-semibold text-lg group-hover:underline transition-all duration-300"
              >
                Saiba mais →
              </button>
            </div>
            <div className="group bg-gradient-to-br from-slate-700/50 to-transparent p-8 rounded-3xl border border-slate-600 hover:border-brand-yellow/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-slate-500/20">
              <div className="w-20 h-20 bg-gradient-to-br from-slate-600 to-slate-400 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-10 h-10 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
                  <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
                </svg>
              </div>
              <h3 className="text-3xl font-bold font-montserrat mb-4 text-center text-white">
                Depoimentos
              </h3>
              <p className="text-gray-300 font-roboto text-center mb-6 leading-relaxed">
                Histórias reais de recuperação e transformação.
              </p>
              <button
                onClick={() => scrollToSection("depoimentos")}
                className="block text-center text-brand-yellow hover:text-yellow-300 font-semibold text-lg group-hover:underline transition-all duration-300"
              >
                Ver depoimentos →
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-20 bg-gradient-to-br from-brand-yellow/10 to-brand-blue/10">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-5xl font-bold text-center font-montserrat mb-16 text-gray-800">
            Depoimentos em Destaque
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white/90 backdrop-blur-sm p-10 rounded-3xl shadow-2xl hover:shadow-3xl smooth-transition-slow hover:scale-105 border border-white/20">
              <p className="text-xl font-roboto italic mb-6 text-gray-700 leading-relaxed">
                "A PATRE mudou minha vida completamente. Encontrei não só
                tratamento, mas uma família que me apoiou em cada passo."
              </p>
              <p className="font-bold font-montserrat text-brand-blue text-lg">
                - Maria S., Familiar
              </p>
            </div>
            <div className="bg-white/90 backdrop-blur-sm p-10 rounded-3xl shadow-2xl hover:shadow-3xl smooth-transition-slow hover:scale-105 border border-white/20">
              <p className="text-xl font-roboto italic mb-6 text-gray-700 leading-relaxed">
                "Profissionalismo excepcional e dedicação total. Recomendo sem
                hesitar para qualquer pessoa que precise de ajuda."
              </p>
              <p className="font-bold font-montserrat text-brand-blue text-lg">
                - Mateus C., Graduado
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Pronto para uma Nova Vida?
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            Entre em contato conosco hoje e dê o primeiro passo rumo à
            recuperação e à esperança.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => scrollToSection("doacoes")}
              className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
            >
              Faça uma Doação
            </button>
            <button
              onClick={() => scrollToSection("localizacao")}
              className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Nossa Localização
            </button>
          </div>
        </div>
      </section>
      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
